import { render, staticRenderFns } from "./ChatBotWidget.vue?vue&type=template&id=6dbe2008&scoped=true"
import script from "./ChatBotWidget.vue?vue&type=script&lang=js"
export * from "./ChatBotWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatBotWidget.vue?vue&type=style&index=0&id=6dbe2008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe2008",
  null
  
)

export default component.exports